import {SelectItem} from "primeng/api";
import {WidgetConfiguration} from "@feature/widget-configs";

export interface DebtorAccountHistoryWidgetConfiguration {
  Sequence: number;
}

export enum DebtorAccountHistorySequence {
  SortByDateForEachReceipt = 1,
  SortReceiptsByDateWithChargesFollowingTheirRespectiveReceipts = 2,
  ListAllChargesThenAllReceipts = 3,
  SortByDateForEachAllocation = 4,
  SortChargesByDateWithReceiptsFollowingTheirRespectiveCharges = 5
}

export const DefaultDebtorAccountHistorySequence : DebtorAccountHistorySequence =
  DebtorAccountHistorySequence.SortChargesByDateWithReceiptsFollowingTheirRespectiveCharges;

export enum SequenceCategory {
  OneLineForEachReceipt = 1,
  SeparateLineForEachReceipt = 2
}

export const oneLineForEachReceiptOptions : SelectItem[] = [
  { label: 'Sort by date',
    value: DebtorAccountHistorySequence.SortByDateForEachReceipt },
  { label: 'Sort receipts by date with charges following their respective receipts',
    value: DebtorAccountHistorySequence.SortReceiptsByDateWithChargesFollowingTheirRespectiveReceipts },
  { label: 'List all charges then all receipts',
    value: DebtorAccountHistorySequence.ListAllChargesThenAllReceipts },
];

export const separateLineForEachReceiptOptions : SelectItem[] = [
  { label: 'Sort by date',
    value: DebtorAccountHistorySequence.SortByDateForEachAllocation },
  { label: 'Sort Charges by date with receipts following their respective charges',
    value: DebtorAccountHistorySequence.SortChargesByDateWithReceiptsFollowingTheirRespectiveCharges },
];

export const getSequenceCategory = (sequence: DebtorAccountHistorySequence) => {
  if (oneLineForEachReceiptOptions.find(x => x.value === sequence))
    return SequenceCategory.OneLineForEachReceipt;
  if (separateLineForEachReceiptOptions.find(x => x.value === sequence))
    return SequenceCategory.SeparateLineForEachReceipt;
  return null;
}

export interface SaveDebtorAccountHistoryWidgetConfigurationRequest {
  WidgetConfiguration: WidgetConfiguration,
  DebtorAccountHistoryWidgetConfiguration: DebtorAccountHistoryWidgetConfiguration
}
